
window.options.slickOptions.slidesToShow = 4;
window.options.slickOptions.slidesToScroll = 4;

window.options.slickOptions.slidesToShow_Tablet = 2;
window.options.slickOptions.slidesToScroll_Tablet = 2;

window.options.slickOptions.slidesToShow_Mobile = 1;
window.options.slickOptions.slidesToScroll_Mobile = 1;
